import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const BasicModule = {
  namespaced: true,
  strict: true,
  state: {
    isLoaded: false,
    states: [],
    professions: [],
    allProfessions: [],
    regions: [],
    regionaryEmails: [],
    employmentTypes: [],
    distanceOrderStates: [],
    extensionOrderStates: [],
    systemSettings: {}
  },
  getters,
  actions,
  mutations
};

export default BasicModule;
